import React from 'react';

const Select = (props) => {
  return(
    <div className="form-group">
      <div className="col-sm-4">
        <label htmlFor={props.name}>{props.title}</label>
        {props.badge ? <span className='badge'>必須</span> : ''}
      </div>
      <div className="col-sm-8">
        <select
          name={props.name}
          value={props.value}
          onChange={props.handleChange}
          >
          {/* <option value="" disabled>{props.placeholder}</option> */}
          {props.options.map(option => {
            return (
              <option
                key={option}
                value={option}
                label={option}>{option}
              </option>
            );
          })}
        </select>
      </div>
  </div>)
}

export default Select;